<!--
/**
* @name: List.vue
* @description: 操作手册
* @author: 于海威
* @create: 2020/08/07 18:04:09
* @update: 2020/08/07 18:04:09
*/
-->

<template>
  <y-view>
    <div slot="left" class="left-panel">
      <h3 class="page-title">操作手册</h3>
      <k-tree :data="treeDataList" hasActions class="mt-1" v-model="tId" childField="children" selectedRule="some" keyField="id" @toggle="onToggle"></k-tree>
    </div>
    <div class="right-content">
      <h3 class="page-title">文章列表</h3>
      <k-table :data="articleList" :height="$root.tableHeightXX" :rightFixedNumber="1" class="mt-1" :columns="initColumns()"></k-table>
    </div>
    <div class="popup_box">
      <k-popup bind="v-if" layout="header, body, close, mask" title="文章内容" :show.sync="isShowPopup">
        <y-form titleWidth="90px" titleAlign="right" contentWidth="400px">
          <y-form-item title="文章内容：">
            <span>{{ articleContent }}</span>
          </y-form-item>
        </y-form>
      </k-popup>
    </div>
  </y-view>
</template>

<script>
import { NESTLE_SYSTEM_BACK_SERVER_SYSTEM_DICT_LIST_TREE_CONDITION, NESTLE_ARTICLE_BACK_SERVER_BACK_ARTICLE_MANAGEMENT_PAGELIST } from "@/assets/modules/apiList";
export default {
  data() {
    return {
      treeDataList: [],
      key: "",
      tId: "",
      articleList: [],
      isShowPopup: false,
      articleContent: "",
    };
  },
  methods: {
    initColumns() {
      return [
        {
          name: "文章编号",
          field: "id",
          style: {
            width: 80,
          },
        },
        {
          name: "文章名称",
          field: "name",
          style: {
            width: 300,
          },
        },
        {
          name: "操作",
          style: {
            width: 60,
            textAlign: "center",
          },
          customRender: (row) => {
            const viewButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onView(row);
                }}
              >
                查看
              </a>
            );
            const downLoadButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onDelete(row);
                }}
              >
                下载
              </a>
            );
            return (
              <div>
                {viewButton}&#12288;{downLoadButton}
              </div>
            );
          },
        },
      ];
    },
    onView(row) {
      this.articleContent = row.content.substring(3, row.content.length - 4);
      this.isShowPopup = true;
    },
    getArticleList() {
      this.$fetch({
        api: "",
        para: {},
      }).then((res) => {
        this.articleList = res;
      });
    },
    getCatList() {
      this.$fetch({
        api: NESTLE_SYSTEM_BACK_SERVER_SYSTEM_DICT_LIST_TREE_CONDITION,
        para: {
          code: "articleType",
        },
      }).then((res) => {
        this.treeDataList = res;
        this.treeDataList[0].__open__ = true;
        this.tId = this.treeDataList[0].id;
      });
    },
    getArticleList() {
      this.$fetch({
        api: NESTLE_ARTICLE_BACK_SERVER_BACK_ARTICLE_MANAGEMENT_PAGELIST,
        para: {
          pageCurrent: 1,
          pageSize: 1000,
          type: 1,
          categoryId: this.tId == this.treeDataList[0].id ? "" : this.tId,
        },
      }).then((res) => {
        this.articleList = res.pageList;
      });
    },
    onToggle() {
      this.getArticleList();
    },
  },
  created() {
    this.getCatList();
  },
};
</script>

<style lang="postcss" module="css">
.search_key {
  width: 160px;
}
</style>
